
require("./mapkit.js"),
  (module.exports = window.mapkit),
  (module.exports.Annotation = window.mapkit.Annotation),
  (module.exports.BoundingRegion = window.mapkit.BoundingRegion),
  (module.exports.Coordinate = window.mapkit.Coordinate),
  (module.exports.CoordinateRegion = window.mapkit.CoordinateRegion),
  (module.exports.CoordinateSpan = window.mapkit.CoordinateSpan),
  (module.exports.Directions = window.mapkit.Directions),
  (module.exports.Geocoder = window.mapkit.Geocoder),
  (module.exports.GeoJSON = window.mapkit.GeoJSON),
  (module.exports.Map = window.mapkit.Map),
  (module.exports.MapPoint = window.mapkit.MapPoint),
  (module.exports.MapRect = window.mapkit.MapRect),
  (module.exports.MapSize = window.mapkit.MapSize),
  (module.exports.Overlay = window.mapkit.Overlay),
  (module.exports.Padding = window.mapkit.Padding),
  (module.exports.Search = window.mapkit.Search),
  (module.exports.Style = window.mapkit.Style),
  (module.exports.TileOverlay = window.mapkit.TileOverlay);
